import { Card, CardBody, Col, Row } from 'reactstrap'
import { CheckBoxButtonGroups } from '../../../../Utils/Constants'
import { checkboxButtonGroupData } from '../../../../Data/Buttons/ButtonGroup'
import StaticCheckBoxButtonGroup from './StaticCheckBoxButtonGroup'
import DynamicCheckBoxButtonGroup from './DynamicCheckBoxButtonGroup'
import CardHeaderCommon from '../../../../Utils/CommonComponents/CardHeaderCommon'

const CheckBoxButtonGroup = () => {
  return (
    <Col sm="12">
      <Card>
        <CardHeaderCommon title={CheckBoxButtonGroups} span={checkboxButtonGroupData} />
        <CardBody className="btn-group-showcase">
          <Row>
            <StaticCheckBoxButtonGroup />
            <DynamicCheckBoxButtonGroup />
          </Row>
        </CardBody>
      </Card>
    </Col>
  )
}

export default CheckBoxButtonGroup